import React from 'react';

var getNavIconFromSlug = function getNavIconFromSlug(slug) {
  if (slug === "/about-us") {
    return "far fa-id-card";
  } else if (slug === "/key-info") {
    return "fas fa-info";
  } else if (slug === "/curriculum") {
    return "fas fa-newspaper";
  } else if (slug === "/parents-children") {
    return "fas fa-child";
  } else if (slug === "/statutory-information") {
    return "fas fa-info";
  } else if (slug === "/admin-services") {
    return "fas fa-mobile";
  } else if (slug === "/covid") {
    return "fas fa-info";
  }

  return "far fa-id-card";
};

export default getNavIconFromSlug;